import {ElectricityCostPath} from '../pages/ElectricityCost';
import {SavingEstimatePath} from '../pages/SavingsEstimate';
import {SiteBuilderPath} from '../pages/SiteBuilder';
import {AddonsPath} from '../pages/Addons';
import {PricingTermPath} from '../pages/PricingTerm';



export const links = [ElectricityCostPath, SavingEstimatePath, SiteBuilderPath,
                AddonsPath, PricingTermPath ]